/* STILL 18.11 · Tördelés: small typographic fixes in the STILL sections and the STILL footer.
   Loaded in <head> with the other STILL head files (snippets/still-perf.liquid, part 'head'), so it runs
   before the quantity and shipping add-ons; it touches only text that needs it.
     1. A number stays with its unit and a range stays in one piece: "30 nap", "1 990 Ft", "1–3 munkanap"
        never break after the number or after the dash (a non-breaking space; a word joiner after the dash).
        "Ft-tól" keeps its hyphen (a non-breaking hyphen, drawn by the STILL NBH font).
     2. An e-mail address may break before the "@" (and only there), so on a 320 px phone
        "info.stilleyewear" and "@gmail.com" sit on two lines instead of breaking inside a word.
     3. The STILL sections say lang="hu" (the store's main language is English, so the page says "en"):
        hyphenation follows Hungarian rules and screen readers read the text in Hungarian.
     4. The texts the quantity and shipping add-ons write ("2 × 19 990 Ft", "Ingyenes szállítás · 1–3
        munkanap alatt", "… 24 990 Ft-tól ingyenes") are fixed in their settings, before those scripts read
        them, so they write the right text themselves on every quantity or lens change.
     5. Other text the STILL scripts write later is fixed as it changes (only the changed text, once per
        frame). Text those add-ons own is left to them: they compare it with what they wrote, and a change
        would make them write it again. A text that is already right is never written, and a text that
        keeps being written back is left alone, so nothing writes back and forth.
     6. 18.12: the order form's thank-you page (Releasit, outside the STILL sections): "1–3 munkanapon" in
        its text stays in one piece. The form is watched only while it exists, and only its thank-you text
        is looked at.
   Text nodes are changed in place (no node is replaced), so the STILL scripts keep their references. */
(function () {
  'use strict';
  if (window.__nxType) return;
  window.__nxType = true;
  var ROOTS = '.nx,.nx-ft';
  var OWNED = '.nx-qty, [data-nx-shipline], [data-nx-free], [data-nx-add]';   // written and checked by the add-ons
  var SKIP = /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION|NOSCRIPT|TEMPLATE|CODE|PRE)$/;
  var UNIT = '(?:Ft|HUF|%|nap|napig|napon|napot|napja|munkanap|db|darab|perc|óra|órá|év|éj|hét|hónap|g|mm|cm|ml|km|×)';
  var NBSP = String.fromCharCode(0xa0), WJ = String.fromCharCode(0x2060), NBH = String.fromCharCode(0x2011);   // no-break space, word joiner, no-break hyphen
  var LATIN = String.fromCharCode(0xc0) + '-' + String.fromCharCode(0x24f);                                      // accented Latin letters
  var RX_THOUSANDS = /(\d) (?=\d{3}(?!\d))/g;                                   // 24 990 → 24 990
  var RX_UNIT = new RegExp('(\\d) (?=' + UNIT + '(?![0-9A-Za-z' + LATIN + ']))', 'g');       // 30 nap → 30 nap
  var RX_RANGE = /(\d)([–—-])(?=\d)/g;                                            // 1–3 → 1–3 (word joiner after the dash)
  var RX_FT_SUFFIX = /(Ft|HUF)-(?=[a-záéíóöőúüű])/g;                              // Ft-tól → Ft-tól (non-breaking hyphen)
  var RX_TEST = /\d[ –—-]\d|\d (?:Ft|HUF|%|nap|munkanap|db|darab|perc|óra|órá|év|éj|hét|hónap|g|mm|cm|ml|km|×)|(?:Ft|HUF)-[a-z]|\S@\S/;

  function fixString(v, inNx) {
    var n = v.replace(RX_THOUSANDS, '$1' + NBSP).replace(RX_UNIT, '$1' + NBSP).replace(RX_RANGE, '$1$2' + WJ);
    if (inNx) n = n.replace(RX_FT_SUFFIX, '$1' + NBH);   // the STILL NBH font draws U+2011 inside .nx
    return n;
  }
  function fixText(t, inNx) {
    var v = t.data;
    if (!RX_TEST.test(v)) return false;
    var n = fixString(v, inNx), changed = n !== v;
    if (changed) t.data = n;
    if (/\S@\S/.test(n) && t.parentNode) splitMail(t);
    return changed;
  }
  function splitMail(t) {
    var v = t.data, m = /([^\s@]+)(@[^\s@]+\.[^\s@]+)/.exec(v);
    if (!m) return;
    var at = m.index + m[1].length;
    var after = t.splitText(at);                 // t keeps "…info.stilleyewear", after starts with "@"
    after.parentNode.insertBefore(document.createElement('wbr'), after);
  }
  function walk(root) {
    var inNx = !!root.closest('.nx');
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP.test(p.nodeName) || p.isContentEditable || p.closest(OWNED)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    for (var i = 0; i < list.length; i++) fixText(list[i], inNx);
  }

  /* 4 · the add-ons' own texts, in their settings (read once, when those scripts start) */
  function prepCfg(sel, keys) {
    var el = document.querySelector(sel);
    if (!el || el.__nxType) return;
    el.__nxType = true;
    try {
      var c = JSON.parse(el.textContent), changed = false;
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i], v = c[k];
        if (typeof v !== 'string') continue;
        var n = fixString(v, true)
          .replace(/ × /g, NBSP + '×' + NBSP)                        // [qty] × [price]: one piece
          .replace(/\]-(?=[a-záéíóöőúüű])/g, ']' + NBH);          // [free]-tól: the hyphen does not break
        if (n !== v) { c[k] = n; changed = true; }
      }
      if (changed) el.textContent = JSON.stringify(c);
    } catch (e) { /* the add-on keeps its own text */ }
  }
  function prep() {
    prepCfg('script[data-nx-qty-cfg]', ['each']);
    prepCfg('script[data-nx-ship-cfg]', ['tag', 'free', 'paid']);
  }

  /* 5 · text written later: only what changed, once per frame */
  var pending = [], queued = false, mo = null;
  function flush() {
    queued = false;
    var l = pending, now = Date.now();
    pending = [];
    try {
      for (var i = 0; i < l.length; i++) {
        var n = l[i], p = n.parentNode;
        if (!p || !n.isConnected) continue;
        if (n.nodeType === 3) {
          if (SKIP.test(p.nodeName) || p.isContentEditable || p.closest(OWNED)) continue;
          // a text that keeps being written back (more than 4 times in quick succession) is left alone
          if (p.__nxTypeN > 4 && now - p.__nxTypeT < 1000) continue;
          if (fixText(n, !!p.closest('.nx'))) {
            p.__nxTypeN = now - (p.__nxTypeT || 0) < 300 ? (p.__nxTypeN || 0) + 1 : 1;
            p.__nxTypeT = now;
          }
        } else if (n.nodeType === 1 && !SKIP.test(n.nodeName) && !n.closest(OWNED)) walk(n);
      }
    } catch (e) { /* the page works as before */ }
  }
  function watch(root) {
    if (!window.MutationObserver || root.__nxTypeWatch) return;
    root.__nxTypeWatch = true;
    if (!mo) mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var r = recs[i];
        if (r.type === 'characterData') pending.push(r.target);
        else for (var k = 0; k < r.addedNodes.length; k++) pending.push(r.addedNodes[k]);
      }
      if (pending.length && !queued) { queued = true; (window.requestAnimationFrame || setTimeout)(flush); }
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }
  function run() {
    try {
      var roots = document.querySelectorAll(ROOTS);
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      for (var i = 0; i < roots.length; i++) {
        var r = roots[i];
        if (r.parentNode && r.parentNode.closest && r.parentNode.closest(ROOTS)) continue;   // nested: done with its root
        if (lang.indexOf('hu') !== 0 && !r.hasAttribute('lang')) r.setAttribute('lang', 'hu');
        walk(r);
        watch(r);
      }
    } catch (e) { /* the page works as before */ }
  }
  /* 6 · the order form's thank-you page: drawn by Releasit after the order goes through */
  var rsiMo = null, rsiEl = null;
  function watchRsi() {
    var w = document.getElementById('rsi_form_wrapper');
    if (!w) return false;
    if (w === rsiEl || !window.MutationObserver) return true;   // already watched (Releasit may build a new one)
    if (rsiMo) rsiMo.disconnect();
    rsiEl = w;
    var fixTy = function () {
      try {
        var c = w.querySelector('.rsi-ctyp-content');
        if (c) { if (!c.hasAttribute('lang')) c.setAttribute('lang', 'hu'); walk(c); }
      } catch (e) { /* the form works as before */ }
    };
    rsiMo = new MutationObserver(fixTy);
    rsiMo.observe(w, { childList: true, subtree: true });
    fixTy();
    return true;
  }
  document.addEventListener('nocta:cod:open', function () {
    var n = 0;
    (function look() { if (!watchRsi() && n++ < 40) setTimeout(look, 250); })();
  });

  function start() { prep(); run(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', function () { setTimeout(run, 0); });
  document.addEventListener('shopify:section:load', function () { setTimeout(start, 0); });   // the theme editor
})();
